const data = [
  {
    id: 1,
    title: "kwaliteit",
    text: "Met een focus op kwaliteit gebruiken we alleen de beste materialen en technieken om duurzame en esthetisch verbluffende afwerkingen te garanderen.",
  },
  {
    id: 2,
    title: "Service",
    text: "Onze schildersdiensten gaan verder dan eenvoudigweg verf aanbrengen op muren, ze zijn gericht op het verwezenlijken van uw visie. Bij ons begrijpen we dat elke klant zijn eigen unieke eisen stelt. Daarom hanteren we een persoonlijke aanpak die naadloos aansluit bij uw specifieke wensen en voorkeuren.",
  },
  {
    id: 3,
    title: "Vertrouwen",
    text: 'Het draait het niet alleen om schilderen, het draait om het schilderen van vertrouwen. Wij begrijpen de waarde van uw vertrouwen en streven ernaar een betrouwbare partner te zijn in al uw schildersbehoeften.',
  },
  {
    id: 4,
    title: "Klantgericht",
    text: "Mocht 'vertrouwen' het canvas zijn van ons schilderwerk, dan is 'klantgericht' de kleur die het uniek maakt. We werken niet alleen naar perfectie op de muur, maar ook naar een perfecte klantbeleving.",
  },
  {
    id: 5,
    title: "Flexibel",
    text: "Wat betekent flexibiliteit voor ons? Het betekent dat we klaar staan om uw uitdagingen en doelen te omarmen. Of het nu gaat om strakke deadlines, veranderende specificaties of onverwachte kansen, wij passen ons aan zonder concessies te doen aan de kwaliteit van onze dienstverlening.",
  },
];

export default data;
